<template>
	<div class="container">
		<div class="row">
			<div class="col-12">

				<div class="swiper-container-wrap two-sliders__wrap two-sliders__wrap--with-pagination">

					<div class="swiper-container swiper-container__one" ref="mySwiperOne">

						<div class="swiper-pagination__wrap">
							<h4 class="swiper-pagination__title">{{msg.experiences}}:</h4>
							<div class="swiper-pagination swiper-no-swiping">
							</div>
						</div>

						<div class="swiper-wrapper">
							<!-- Slides -->
								<div v-for="slide in slides" :key="slide.id" class="swiper-slide">
									<a href="#" class="swiper-slide__link">

										<div class="swiper-slide__img-wrap">
											<img class="swiper-slide__img" :src="slide.article_osnovna_slika_url" alt>
										</div>

									</a>
								</div>
						</div>

					</div>

					<div class="swiper-container swiper-container__two" ref="mySwiperTwo">

						<div class="swiper-wrapper">
							<!-- Slides -->
							<div v-for="slide in slides" :key="slide.id" class="swiper-slide">
								<a href="#" class="swiper-slide-card">

									<header class="swiper-slide-card__header swiper-slide-card__header--no-overlay">
										<div class="swiper-slide-card__header-title-wrap swiper-slide-card__header-title-wrap--no-image">	
											<p class="swiper-slide-card__header-overtitle">{{ slide.article_aboveheadline }}</p>
											<h3 class="swiper-slide-card__header-title">{{ slide.content_section_name }}</h3>
										</div>
									</header>

									<div class="swiper-slide-card__body" v-html="slide.article_abstract">
									</div>

									<footer class="swiper-slide-card__footer">
										<a :href="slide.friendly_path" class="btn btn-primary">{{msg.read_more}}</a>
									</footer>

								</a>
							</div>
						</div>

						<div class="swiper-button-prev">
							<svg class="progress-ring" width="70" height="70">
								<circle class="progress-ring__circle progress-ring__circle--left" stroke="#ff7843" stroke-width="2" fill="transparent" r="35" cx="35" cy="35"></circle>
							</svg>
						</div>
						<div class="swiper-button-next">
							<svg class="progress-ring" width="70" height="70">
								<circle class="progress-ring__circle progress-ring__circle--right" stroke="#ff7843" stroke-width="2" fill="transparent" r="35" cx="35" cy="35"></circle>
							</svg>
						</div>


					</div>

				</div>

			</div>
		</div>
	</div>
</template>
<script>
	import Swiper from "swiper";
	import { mapState } from "vuex";

	export default {
		props: {
			slides: Object
		},
		// name: "Apartments",
		data: () => ({
			selected: 'All',
			mySwiperOne: {},
			mySwiperTwo: {},
			startingPosition: 0,
			isLoading: false,
			activeFilter: "All",
			
		}),
		mounted() {
			// console.log(this.slides, 'slides');
			let slides = this.slides;
			this.mySwiperOne = new Swiper(".two-sliders__wrap--with-pagination .swiper-container__one", {
				slidesPerView: 1,
				spaceBetween: 90,
				// observer: true,
				pagination: {
					el: '.two-sliders__wrap--with-pagination .swiper-container__one .swiper-pagination',
					// type: 'bullets',
					type: 'bullets',
					clickable: true,
					renderBullet: function (index, className) {
						// return '<span class="' + className + '">' + (index + 1) + '</span>';
						return '<span class="' + className + '">' + slides[index].content_section_name + '</span>';
					}
					/*renderCustom: function (swiper, current, total) {
						return current + ' of ' + total;
					}*/
				},
				navigation: {
					nextEl: '.two-sliders__wrap--with-pagination .swiper-button-next',
					prevEl: '.two-sliders__wrap--with-pagination .swiper-button-prev',
				},
				breakpoints: {
					991: {
						slidesPerView: 1,
						spaceBetween: 20
					}
				},
				/*controller: {
					control: this.mySwiperTwo,
				},*/

			}),
			this.mySwiperTwo = new Swiper(".two-sliders__wrap--with-pagination .swiper-container__two", {
				// observer: true,
				spaceBetween: 30,
				effect: 'fade',
				fadeEffect: { crossFade: true },
				slidesPerView: 1,
				autoHeight: true,
				/*pagination: {
					el: '.swiper-container__one--with-pagination .swiper-pagination',
					type: 'bullets',
					clickable: true
				},*/
				/*navigation: {
					nextEl: '.swiper-container__one--with-pagination .swiper-button-next',
					prevEl: '.swiper-container__one--with-pagination .swiper-button-prev',
				}*/
				/*controller: {
					control: this.mySwiperOne,
				},*/

			}),
    		this.mySwiperOne.controller.control = this.mySwiperTwo,
			this.mySwiperTwo.controller.control = this.mySwiperOne;

		},
		methods: {
			selectedFilter(event) {
				
				if (!event.target.classList.contains("filters-menu__link--active") ) {
					event.preventDefault();
					this.isLoading = true;
					// this.activeFilter = event.target.textContent;
					// console.log(event.target);
					this.activeFilter = event.target.attributes["data-category"].value;
					// console.log(this.activeFilter);
					// console.log(this.$refs.mySwiperOne.slides, "Swiper");

					
					// this.mySwiperOne.slideTo(0,400,false);
					this.$data.selected = this.activeFilter;
					// simulate AJAX
					setTimeout(() => {
						this.isLoading = false;
					}, 500);

					let sliderObject = this.mySwiperOne;
					// console.log(sliderObject, "Swiper");

					setTimeout(() => {
						sliderObject.slideTo(0, 600);
					}, 0);

				}

			}
		},
		computed: {
			/*filteredItem() {
				var category = this.activeFilter;
				if (category === "All") {
					return this.slides;
				} else {
					return this.slides.filter(function(cat) {
						return cat.category === category;
					});
				}
			}*/
			...mapState({
				msg: state => state.msg,
			})
		}

};
</script>
<style>

</style>